// import dJSON from 'dirty-json';
// import '../node_modules/@lottiefiles/lottie-player/dist/lottie-player';

import './js/base/base-start';
import './js/global';

// modules - core
import './modules/core/accordion/module';

// modules
import './modules/theme/hero-section/module';
import './modules/theme/services-slider/module';
import './modules/theme/testimonials-slider/module';
import './modules/theme/locations/module';
import './modules/theme/tabbed-content/module';
import './modules/theme/testimonials-simple/module';
import './modules/theme/timeline-slide/module';
import './modules/theme/faq/module';
import './modules/theme/project-gallery/module';
import './modules/theme/carousel-content/module';

import './modules/evox/category-section/module';
import './modules/evox/brands/module';
import './modules/evox/brands-grid/module';
import './modules/evox/item-merch/module';
import './modules/evox/megamenu/module';

// layouts

// leave me last
import './js/base/base-end';
